export function validateCaptcha(value) {
    const length = value.length;
    if( length < 1 || length > 5) {
        return {
            value: value,
            isValid : false,
            message : "Error: Please enter the text in the captcha image"
        }
    }
    else if (length >= 1 && length <= 5) {
        return {
            value: value,
            isValid : true,
            message : ""
        }
    }
}

export default validateCaptcha;


// WEBPACK FOOTER //
// ./src/helper/validateCaptcha.js